import { h } from 'preact';
// import Store from 'store/store';

const getOneTrustCookieSettingButtonText = (() => {
	let cache = null;
	return () => {
		if (cache) return cache;
		if (typeof window?.OneTrust?.GetDomainData !== 'function') {
			return null;
		}
		return cache = window.OneTrust.GetDomainData()?.CookieSettingButtonText || null;
	};
})();

export function showCookieConsent() {
	window.OneTrust?.ToggleInfoDisplay?.();
}

export function renderCookieConsentLink(linkName) {
	// const clientGeo = Store.get().client?.geo;
	let name = getOneTrustCookieSettingButtonText() || linkName;

	// if (clientGeo?.countryCode !== 'us') {
	// 	name = 'Cookie Notice';
	// }

	return (
		<button class="cookie-consent" onClick={showCookieConsent}>
			{/* {clientGeo?.countryCode === 'us' && <img class="do-not-sell" src={`${__IMAGE_ROOT__}/privacyoptions.svg`} role="presentation" />} */}
			{name}
		</button>
	);
}